import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Post, PostReaction, Report } from "../../app/app.interfaces";
import { LoginRequired } from "../../decorators/login.required";
import { AuthService } from "../../services/auth.service";
import { FormHelper } from "../../helpers/form.helper";
import { UserGroupService } from "../../services/user-group.service";
import { ApiService } from "../../services/api.service";
import { IonicHelper } from "../../helpers/ionic.helper";
import { EventService } from "../../services/event.service";
import { UserService } from "../../services/user.service";

@Component({
  selector: 'report-create',
  templateUrl: 'report-create.html'
})

export class ReportCreate implements OnInit{

	form: FormGroup;
	@Input() subject: Post|PostReaction;
	
	@Output() reported: EventEmitter<string|void> = new EventEmitter<string|void>();

	constructor (private formHelper: FormHelper,
							 private formBuilder: FormBuilder,
							 public authService: AuthService,
							 public userGroupService: UserGroupService,
							 private apiService: ApiService,
							 private ionic: IonicHelper,
							 private eventService: EventService,
							 private userService: UserService){


		this.form = this.formBuilder.group({
			message: ['', Validators.compose([Validators.minLength(10), Validators.required])]
		});

	}

	cancel(): void{
		this.reported.emit();
	}

	ngOnInit(): void {

	}

	submitForm(): void {
    
		this.ionic.toggleLoader(true);

		if(this.form.valid){
		  		  
      let newReport: Report = {
        message: this.form.get('message').value      
      };
      
      if(this.subject['@type']=='Post'){		  
        newReport.post = this.subject as Post;
      }
      else if(this.subject['@type']=='PostReaction') {
        newReport.postReaction = this.subject as PostReaction;
      }
      
      this.apiService.createResource('reports', newReport).then((report) => {
        
        this.ionic.toggleLoader(false);
	      this.ionic.toast('REPORT.TOAST.'+this.subject['@type']);
        this.reported.emit();
        this.form.reset();
        
      }).catch(err => {
				console.error(err);
        this.ionic.toggleLoader(false);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
      });
      

		}
		else {

			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'REPORT.ERROR',
				null,
				'REPORT.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);

		}

	}

}




// WEBPACK FOOTER //
// ./src/partials/report-create/report-create.ts